import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  
  DateField,
  DateTimeInput,
  ReferenceInput,
  SelectInput,
  translate,
  FunctionField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter,
  Toolbar,
  SaveButton
} from "react-admin";
import CheckboxInput from "../../inputs/CheckboxInput";
import ColorPickerInput from "../../inputs/ColorPickerInput";
import { monterColor } from "../../theme/monterColors";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";
import { email } from "../../validators/email";
import { withStyles } from '@material-ui/core';
import YesNoField from "../../fields/YesNoField";

const ColorField = ({ record }) => (
  <span
    title="Barva v koledarju"
    style={{ display: "inline-block", width: 18, height: 18, borderRadius: "50%", backgroundColor: monterColor(record) }}
  />
);
const toolbarStyles = {
  toolbar: {
      display: 'flex',
      justifyContent: 'space-between',
  },
};


const AppUserFilter = props => (
  <Filter {...props}>
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.id"
      source="id"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.email"
      source="email"
    />
    <TextInput label="resources.misc.fields.firstName" source="firstName" />
    <TextInput label="resources.misc.fields.lastName" source="lastName" />
    <CheckboxInput
      label="resources.misc.fields.active"
      source="active"
      options={{ defaultToggled: true }}
    />
  </Filter>
);

export const AppUserList = props => (
  <List {...props} exporter={false} filters={<AppUserFilter />}  bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.username" source="username" />
      <TextField label="resources.misc.fields.firstName" source="firstName" />
      <TextField label="resources.misc.fields.lastName" source="lastName" />
      <YesNoField label="resources.misc.fields.active" source="active" />
      <ColorField label="Barva" />
      <EditButton label="" /> 
    </Datagrid>
  </List>
);

const AppUserTitle = ({ record }) => {
    return (
      <span>Monter {record ? [record.firstName, record.lastName].filter(Boolean).join(" ") || record.username : ""}</span>
    );
};

const cardActionStyle = {
    zIndex: 2,
    display: "inline-block",
    float: "right"
};

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

export const AppUserShow = props => (
  <Show title={<AppUserTitle />} actions={<Actions />} {...props}>
    <SimpleShowLayout>
      <TextField label="resources.misc.fields.username" source="username" />
      <TextField label="resources.misc.fields.firstName" source="firstName" />
      <TextField label="resources.misc.fields.lastName" source="lastName" />
      <TextField label="resources.misc.fields.email" source="email" />
      <YesNoField label="resources.misc.fields.active" source="active" />
      <ColorField label="Barva v koledarju" addLabel />
      <DateField label="resources.misc.fields.createdAt" source="createdAt" />
      <TextField label="resources.misc.fields.id" source="id" />
    </SimpleShowLayout>
  </Show>
);

// username first, then the name; the email is optional and comes last
export const AppUserEdit = ({ permissions, ...props }) => (
  <Edit title={<AppUserTitle />}   {...props}>
    <SimpleForm>
      <TextInput
        disabled
        label="resources.misc.fields.username"
        source="username"
      />
      <TextInput
        label="resources.misc.fields.firstName"
        source="firstName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.lastName"
        source="lastName"
        validate={[required()]}
      />
      <TextInput
        label="E-pošta (neobvezno)"
        source="email"
        type="email"
        validate={[email()]}
      />
      <TextInput
        label="resources.misc.fields.password"
        source="password"
        type="password"
        validate={[passwordEdit()]}
      />
      <TextInput
        label="resources.misc.fields.password2"
        source="password2"
        type="password"
        validate={[passwordEquals()]}
      />
      <CheckboxInput
        label="resources.misc.fields.active"
        source="active"
        options={{ defaultToggled: true }}
      />
      <ColorPickerInput source="color" />
    </SimpleForm>
  </Edit>
);

export const AppUserCreate = ({ permissions, ...props }) => (
  <Create title="Nov monter" {...props}>
    <SimpleForm redirect="list" defaultValue={{ active: true }}>
      <TextInput
        label="resources.misc.fields.username"
        source="username"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.firstName"
        source="firstName"
        validate={[required()]}
      />
      <TextInput
        label="resources.misc.fields.lastName"
        source="lastName"
        validate={[required()]}
      />
      <TextInput
        label="E-pošta (neobvezno)"
        source="email"
        type="email"
        validate={[email()]}
      />
      <TextInput
        label="resources.misc.fields.password"
        source="password"
        type="password"
        validate={[required(), password()]}
      />
      <TextInput
        label="resources.misc.fields.password2"
        source="password2"
        type="password"
        validate={[required(), passwordEquals()]}
      />
      <CheckboxInput
        label="resources.misc.fields.active"
        source="active"
        options={{ defaultToggled: true }}
      />
      <ColorPickerInput source="color" />
    </SimpleForm>
  </Create>
);
